<template>
  <div v-if="!product" class="details loadingWindow">
    <img src="../assets/img/loading.gif" alt="">
  </div>
  <div class="details" v-else-if="product && !isMobile">
    <div class="category-buttons">
      <ul>
        <li v-for="(item, index) in groups">
          <div class="group-button-container">
            <div class="image-placeholder" @click="navGo(item.ProductGroup_id)">
              <img class="button-image" :src="item.Image" alt="">
            </div>
            <!-- <p v-if="$i18n.locale == 'en'" class="group-button-name">{{item.Name}}</p> -->
            <p v-if="$i18n.locale == 'ch'" class="group-button-name">{{item.Description}}</p>
          </div>
        </li>
      </ul>
    </div>
    <!--product breadcrumb-->
    <div class="breadcrumb-container">
      <img class="bread-img" :style="{cursor: 'pointer'}" src="../assets/img/breadcrumb-home.png" @click="$router.push('/home')">
      <el-breadcrumb class="breadcrumb-products" separator="/">
        <!-- <el-breadcrumb-item><a class="bread-text no-pointer">{{ $t('products') }}</a></el-breadcrumb-item> -->
        <el-breadcrumb-item ><a style="color: #380D64 !important;" class="bread-text has-pointer" @click="goToGroup(product.ProductGroup)">{{product.ProductGroup.Name}}</a></el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="$i18n.locale == 'ch' && product.ProductGroup"><a class="bread-text has-pointer" @click="goToGroup(product.ProductGroup)">{{product.ProductGroup.Description}}</a></el-breadcrumb-item> -->
        <el-breadcrumb-item ><a style="color: #380D64 !important;" class="bread-text has-pointer" @click="goToCategory(product.ProductCategory)">{{product.ProductCategory.Name}}</a></el-breadcrumb-item>
        <el-breadcrumb-item><a class="bread-text no-pointer">{{product.Name}}</a></el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="$i18n.locale == 'ch' && product.ProductCategory"><a class="bread-text has-pointer" @click="goToCategory(product.ProductCategory)">{{product.ProductCategory.Description}}</a></el-breadcrumb-item> -->
      </el-breadcrumb>
    </div>
    <!--end product breadcrumb-->
    <div class="display">
      <!--product image-->
      <div class="productsingleli">
        <div class="ps_left">
          <div class="product-single__photo-wrapper">
            
            <!-- <div v-show="product.Images.length !== 0">
              <vue-h-zoom
                :image="bigImg || product.Images[0]"
                :image-full="zoomImg || product.Large_Images[0]"
                :zoom-level="2"
                :width="zoom.width"
                :height="zoom.height"
                :zoom-window-size="1"
                :zoom-window-x="zoom.zoomX"
                :zoom-window-y="zoom.zoomY"
              >
              </vue-h-zoom>
            </div>
            <img class="desktop-image" v-if="product.Images.length === 0" :src="require('../assets/img/defaultImg.png')" alt=""> -->
              <img class="desktop-image" v-if="product.Images[0]" :src="bigImg || product.Images[0]" alt="" @click="toggleImgModalVisibility(true, zoomImg ? zoomImg : product.Large_Images[0])">
              <img class="desktop-image" v-else :src="require('../assets/img/defaultImg.png')" alt="">
               <!-- <div class="favorite-button" v-if="loggedIn" @click="favoriteProduct(product)">
                <font-awesome-icon v-if="!favorited" icon="heart" class="like-btn" :style="{ color: 'white', fontSize: '35px',  }"/>
                <font-awesome-icon v-if="favorited" icon="heart" class="like-btn" :style="{ color: 'rgb(224, 36, 94)', fontSize: '35px',  }"/>
              </div> -->
          </div>
        </div>
        <div class="ps_right">
          <div class="thumbnails-wrapper">
            <ul>
              <li v-for="(item,index) in product.Images" :class="isactive == index?'isactive':''" :key="index">
                <a href="javascript:void(0)" @click="tabImg(index)"><img :src="item" alt=""></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--end product image-->
      <!--product detail-->
      <div class="product-single__meta">
        <div v-if="product.IsGreatDeal || product.IsPromotion || product.IsNewArrival || product.BuyAGetB_promotion" class="tag-container">
          <div v-if="product.IsGreatDeal" class="tag-1">
            {{ $t('top') }}
          </div>
           <div v-if="product.IsPromotion" class="tag-2">
            {{ $t('sale') }}
          </div>
           <div v-if="product.IsNewArrival" class="tag-3">
            {{ $t('new') }}
          </div>
           <div v-if="product.BuyAGetB_promotion" class="tag-4">
            {{ $t('buy_one_get_one') }}
          </div>
        </div>
        <p v-if='$i18n.locale=="en"' class="product-single__brand" @click="onClickBrand(product.Brand)">{{product.English_Details_Brand}}</p>
        <p v-if='$i18n.locale=="ch"' class="product-single__brand" @click="onClickBrand(product.Brand)">{{product.Chinese_Details_Brand}}</p>
        <!-- <h1 class="product-single__title" v-if='$i18n.locale=="en"'>{{product.Name}}</h1> -->
        <h1 class="product-single__title">{{product.Name}}</h1>
        <!-- <h1 class="product-single__title" v-if='$i18n.locale=="ch"'>{{product.Description}}</h1> -->
        <div class="product_reviews_below_title">
          <!--review star-->
          <!-- <span class="shopify-product-reviews-badge" data-id="2236667330658"></span>
          <a href="">
            <div class="price__regular">{{review}} review</div>
          </a>
          <a href="">
            <div class="price__regular">Write a review</div>
          </a> -->
          <div class="review-container">
            <div class="star-img-container">
              <img v-for="(item,index) in starIndex" :data-index="index" :key="index" class="star-img" :src="item" alt="">
              <p class="star-text">{{this.starRating}}</p>
            </div>
          </div>
          <!--end review star-->
          <!-- <div class="product__price">${{product.Price.toFixed(2)}}</div> -->
          <div class="price-marge">
              <!-- <div :class="['product__price', (product.IsPromotion || product.BuyAGetB_promotion) ? 'promo' : '']"><span>${{product.Price.toFixed(2)}}</span></div> -->
              <div class="price_original_detail_page" v-show="product.IsPromotion"><span>${{product.OriginalPrice}}</span></div>
          </div>

          <!-- <div class="shipping-blurb">
            <p>{{ $t('same_day_delivery') }}</p>
            <p>{{ $t('free_delivery_over') }}</p>
            <p>{{ $t('the_first_order') }}</p>
          </div> -->
          <div class="delivery_txt">
            <span v-show="product.InventoryQuantity<product.MinStockRange&&product.InventoryQuantity>0">{{product.InventoryQuantity}} {{ $t('leftInStock') }}</span>
          </div>
          <div class="pro_tt_dt">{{product.Description}}</div>
          <!-- <div class="qty_and_cart"> -->
            <!--qty-->
            <!-- <div class="mobileqty">
              <label class="qty_lebel">QTY</label>
              <div class="qty_input">
                <el-input-number v-model="num" size="small" :min="1" :max="product.InventoryQuantity" label=""></el-input-number>
              </div>
            </div> -->

            <!--add to cart btn-->
            <div v-if="product.InventoryQuantity>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
              <input v-on:click="addToCart(product, $event)" type="button" class="btn product-form__cart-submit fakeBUt" :value="$t('addToCart')">
              <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                <span id="AddToCartText-product-template">{{ $t('addToCart') }}</span>
              </button>
            </div>
            <div v-else class="product-form__item product-form__item--submit product-form__item--no-variants">
              <input type="button" class="soldOut product-form__cart-submit fakeBUt" :value="$t('outOfStock')">
              <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                <span id="AddToCartText-product-template">{{ $t('soldOut') }}</span>
              </button>
            </div>
            <!--end add to cart btn -->
          <!-- </div> -->
          <!-- <span class="time_tip">{{activeQuantity}} {{ $t('currentlyInCart') }}</span> -->

          <div class="pro_row_detail" v-if="upperLimitGlobal && lowerLimitGlobal && (lowerLimitGlobal < upperLimitGlobal)">
            <span v-if="loggedIn && product.InventoryQuantity >= lowerLimitGlobal && product.InventoryQuantity <= upperLimitGlobal" class="pro_tt_dt">{{$t('stock')}}: </span>
            <span v-if="loggedIn && product.InventoryQuantity >= lowerLimitGlobal && product.InventoryQuantity <= upperLimitGlobal" class="pro_tt_dt">{{product.InventoryQuantity ? product.InventoryQuantity : 0}}</span>
            <span v-if="loggedIn && product.InventoryQuantity && product.InventoryQuantity > upperLimitGlobal" class="pro_tt_green_dt">{{$t('available')}}</span>
            <span v-if="loggedIn && product.InventoryQuantity < lowerLimitGlobal" class="pro_tt_red_dt">{{$t('outOfStock')}}</span>

            <span v-show="product && product.Price || false" v-if="loggedIn && showPrice" class="pro_tt_price_dt">${{product ? product.Price.toFixed(2) : ''}}</span>
          </div>

          <div class="pro_row_detail" v-if="!upperLimitGlobal || !lowerLimitGlobal || (lowerLimitGlobal >= upperLimitGlobal)">
            <!-- <span v-if="loggedIn && showInstock && product.InventoryQuantity >= this.showLimit1 && product.InventoryQuantity <= this.showLimit2" class="pro_tt_dt">{{$t('stock')}}: </span>
            <span v-if="loggedIn && showInstock && product.InventoryQuantity >= this.showLimit1 && product.InventoryQuantity <= this.showLimit2" class="pro_tt_dt">{{product.InventoryQuantity ? product.InventoryQuantity : 0}}</span>
            <span v-if="loggedIn && showInstock && product.InventoryQuantity && product.InventoryQuantity > this.showLimit2" class="pro_tt_green_dt">{{$t('available')}}</span>
            <span v-if="loggedIn && showInstock && product.InventoryQuantity < this.showLimit1" class="pro_tt_red_dt">{{$t('outOfStock')}}</span> -->
            <span v-if="loggedIn && product.InventoryQuantity >= product.ProductCategory.MinQuantity && product.InventoryQuantity <= product.ProductCategory.MaxQuantity" class="pro_tt_dt">{{$t('stock')}}: </span>
            <span v-if="loggedIn && product.InventoryQuantity >= product.ProductCategory.MinQuantity && product.InventoryQuantity <= product.ProductCategory.MaxQuantity" class="pro_tt_dt">{{product.InventoryQuantity ? product.InventoryQuantity : 0}}</span>
            <span v-if="loggedIn && product.InventoryQuantity && product.InventoryQuantity > product.ProductCategory.MaxQuantity" class="pro_tt_green_dt">{{$t('available')}}</span>
            <span v-if="loggedIn && product.InventoryQuantity < product.ProductCategory.MinQuantity" class="pro_tt_red_dt">{{$t('outOfStock')}}</span>

            <span v-show="product && product.Price || false" v-if="loggedIn && showPrice" class="pro_tt_price_dt">${{product ? product.Price.toFixed(2) : ''}}</span>
          </div>
          <div class="pro_tt_dt" v-if="product.RefNum && product.RefNum != ''">{{product.RefNum}}</div>
          <span v-if="loggedIn" class="pro_tt_dt">{{product.LotNum}}</span>
          <div class="sharing-container">
            <p>{{ $t('share') }}</p>
            <ShareNetwork
              v-for="network in networks"
              :network="network.network"
              :key="network.network"
              :url="sharing.url"
              :title="sharing.title"
              :description="sharing.description"
              :quote="sharing.quote"
              :hashtags="sharing.hashtags"
              :twitterUser="sharing.twitterUser"
            >
              <img class="icon" :src="network.icon" alt />
            </ShareNetwork>
          </div>
          <div v-if="product.IsProposition65" class="warning">
            <img src="../assets/img/warning.png" alt="">
            <span>
              For more information:
              <a class="warning-link" href="https://www.p65warnings.ca.gov/">www.P65Warnings.ca.gov</a>
            </span>
          </div>
        </div>
      </div>
      <!--end product detail-->
    </div>

    <div class="details-page-width">
      <!--description-->
      <div class="product-single__description rte" v-if="product.rich_text_description">
        <!-- <h2>{{ $t('description') }}</h2> -->
        <h2 class="section-header__title">{{ $t('details_afm') }}</h2>
        <template></template>
        <!-- <div class="new-detail-container">
          <div class="new-detail-table">
            <div class="new-detail-line odd">
              <p class="detail-title">{{ $t('brand') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Brand}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Brand}}</p>
              <p class="detail-title">{{ $t('brandOrigin') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Brand_Origin}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Brand_Origin}}</p>
            </div>
            <div class="new-detail-line even">
              <p class="detail-title">{{ $t('netContent') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_NetContent}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_NetContent}}</p>
              <p class="detail-title">{{ $t('madeIn') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Made_In}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Made_In}}</p>
            </div>
            <div class="new-detail-line odd">
              <p class="detail-title">{{ $t('ingredients') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Ingredients}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Ingredients}}</p>
              <p class="detail-title">{{ $t('organic') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Organic}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Organic}}</p>
            </div>
            <div class="new-detail-line even">
              <p class="detail-title">{{ $t('containsSugar') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Contains_Sugar}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Contains_Sugar}}</p>
              <p class="detail-title">{{ $t('flavor') }}</p>
              <p v-if="$i18n.locale == 'en'" class="detail-desc">{{product.English_Details_Flavor}}</p>
              <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{product.Chinese_Details_Flavor}}</p>
            </div>
          </div>
        </div> -->
        <div class="rich-text-container">
          <p class="rich-text" v-if="product.rich_text_description">
            <span v-html="product.rich_text_description"></span>
          </p>
        </div>
      </div>
      <!--end description-->
      <!--recommended-->
      <div class="page-width">
        <pcRecommended :isShowButton="false"></pcRecommended>
      <div class="recommended-more-container">
        <!-- <button class="recommended-more-button" @click="clickShowMoreRecommended()">{{ $t('showMore') }}</button>-->
      </div>
      <!-- <div class="bottom-temp">
        <img src="../assets/img/bottomtemp.png" alt="">
      </div> -->
    <!-- <div class="home-footer">
      <div class="icon-col" style="borderRight: 1px solid rgba(0, 0, 0, 0.25)">
        <div class="homeFooter-img">
          <img src="../assets/img/headset.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{$t('customer_service')}}</h2>
          <p>{{ $t('call_chat_visit') }}</p>
        </div>
      </div>
      <div class="icon-col">
        <div class="homeFooter-img">
          <img src="../assets/img/truckHome.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{ $t('free_shipping') }}</h2>
          <p>{{ $t('get_shopafm_free') }}</p>
        </div>
      </div>
      <div class="icon-col" style="borderLeft: 1px solid rgba(0, 0, 0, 0.25)">
        <div class="homeFooter-img">
          <img src="../assets/img/onlinePayment.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{$t('online_payment')}}</h2>
          <p>{{ $t('we_accept_all') }}</p>
        </div>
      </div>
    </div> -->

      </div>
      <!--end recommended-->
    </div>

    <!-- what is this for? not working 7/21-->
    <!-- <div @click="clickPrev(product.ProductNum)" class="banner-button-prev" key="banner_swiper_prev">
      <font-awesome-icon icon="chevron-left" :style="{ color: '#818181', fontSize: '55px', marginRight: '10px' }"/>
    </div>
    <div @click="clickNext(product.ProductNum)" class="banner-button-next" key="banner_swiper_next">
      <font-awesome-icon icon="chevron-right" :style="{ color: '#818181', fontSize: '55px', marginLeft: '10px'  }"/>
    </div> -->

  </div>
  <div v-else-if="isMobile">
    <mobileProductDetails />
  </div>
</template>
<script type="text/javascript">
  Vue.use(VueHZoom);
</script>
<script>
import VueSocialSharing from "vue-social-sharing";
import { mapActions, mapMutations, mapState } from 'vuex';
import VueHZoom from 'vue-h-zoom';
import Router from 'vue-router';
import Vue from 'vue';

import smoothproducts from '../assets/js/smoothproducts.min';
import breadcrumb from '../components/breadcrumb'
import star0 from '../assets/img/star0.jpg'
import star1 from '../assets/img/star1.jpg'
import star2 from '../assets/img/star2.jpg'
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
import productCard from "./productCard";
import fbicon from "../assets/img/facebook_icon.png";
import twittericon from "../assets/img/twitter_icon.png";
import pinteresticon from "../assets/img/pinterest_icon.png";
import whatsappicon from "../assets/img/whatsapp_icon.png";
import lineicon from "../assets/img/line_icon.png";
import mobileProductDetails from './mobile/mobileProductDetails';
import pcRecommended from "../components/pc-recommended/pc-recommended";
import busUtil from "../assets/js/util";

Vue.use(VueSocialSharing);
Vue.use(VueHZoom);
Vue.component('originalVueZoom', VueHZoom);
const newZoom = Vue.component('originalVueZoom').extend({
  methods: {
    updateThumbnailPos: function () {
      const el = this.$refs.thumbnail;
      let elementDim = el.getBoundingClientRect();
      this.thumbnailPos = {
        top: elementDim.top,
        left: elementDim.left,
      }
    },
  }
});

import {
  setSeoFun
} from '../common'

export default {
  name: "productDetails",
  components: {
    breadcrumb,
    VueHZoom: newZoom,
    productCard,
    mobileProductDetails,
    pcRecommended
  },
  data() {
    return {
      sharing: {
        // url: "https://afmstage-web.truckxi.com",
        url: "https://smilinghome-web.truckxi.com/.com",
        title: "Smiling Home!",
        description: "Food",
        quote: "quality and authenticity",
        hashtags: "food",
        twitterUser: "",
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: fbicon,
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: twittericon,
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: pinteresticon,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: whatsappicon,
        },
        {
          network: "line",
          name: "Line",
          icon: lineicon,
        },
      ],

      starRating: 0,
      starIndex: [],
      favorited: false,
      zoom: {
        screenWidth: 0,
        width: 0,
        height: 0,
        zoomX: 0,
        zoomY: 0,
      },
      num: 0, // number count
      review: 0,
      cartCount: 0,
      productDetail: {},
      bigImg: "",
      zoomImg: "",
      isactive: 0, //click
      //review info
      reviews:false,//show rview submit
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          {required: true, errorMessage: 'name can not be empty', trigger: 'blur'}
        ],
        email: [
          {required: true, errorMessage: 'email can not be empty', trigger: 'blur'}
        ],
        title: [
          {required: true, errorMessage: 'title can not be empty', trigger: 'blur'}
        ],
        body: [
          {required: false, errorMessage: '', trigger: 'blur'}
        ]
      },
      value2: null, //piclk star level
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'] //star color = { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted: function() {
    // this.sharing.url = 'https://afmstage-web.truckxi.com' + this.$router.currentRoute.fullPath;
    this.sharing.url = 'https://shopafm.com' + this.$router.currentRoute.fullPath;
  },
  methods: {
    ...mapActions('products', ['fetchProductDetails', 'getPrev', 'getNext']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
      ...mapActions('products', ['addProductToFavorites', 'getFavorites', 'removeProductFromFavorites']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapMutations('navbar', ['toggleProductDetailImgVisibility', 'toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    tabImg(num) {
      this.bigImg = this.product.Images[num]; // right side big img
      this.zoomImg = this.product.Large_Images[num]; // zoom big img
      this.isactive = num; // tab the img
    },
    initializeTabImg() {
      this.bigImg = "";
      this.zoomImg = "";
      this.isactive = 0;
    },
    goToProductDetail(product) {
      this.$router.push({
        name: 'productDetails',
        query: { productNum: product.ProductNum}
      })
    },
    isOutOfStock(product) {
      //if(product.IsOverSaleable) {
        //return false
      //}
      return product.InventoryQuantity > 0 ? false : true
    },
    navGo(item) {
      let id = item;
      const group = this.groups.filter( group => group.ProductGroup_id === id)[0];
      if(this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if(this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
           this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 1000);
        }else {
          this.activeGroup = group.Name;
           this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 1000);
        }
      } else {
         this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 1000);
      }
    },
    handleResize() {
      this.zoom.screenWidth = window.innerWidth;
        this.zoom.width = 650;
        this.zoom.height = 650;
        this.zoom.zoomX = 950;
        this.zoom.zoomY = 100;
      // if (this.zoom.screenWidth>1139) {
      //   this.zoom.width = 400;
      //   this.zoom.height = 400;
      //   this.zoom.zoomX = 400;
      //   this.zoom.zoomY = 100;
      // } else if (this.zoom.screenWidth<1140 && this.zoom.screenWidth>892) {
      //   this.zoom.width = 300;
      //   this.zoom.height = 300;
      //   this.zoom.zoomX = 400;
      //   this.zoom.zoomY = 100;
      // } else if (this.zoom.screenWidth<893 && this.zoom.screenWidth>772) {
      //   this.zoom.width = 278;
      //   this.zoom.height = 278;
      //   this.zoom.zoomX = 300;
      //   this.zoom.zoomY = 100;
      // }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart')
      })
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    addToCart: function(item, e) {
      // if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
      //   this.toggleWarehouseSelectionModalVisibility(true);
      //   return;
      // }
      // if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
      //   this.toggleZipcodeModalVisibility(true);
      //   return;
      // }
      busUtil.$emit('addToCartDrop', e, item)
      item.quantity = this.num;
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
      }
    },
    // review list change
    customerList() {
      this.reviews = !this.reviews
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toggleImgModalVisibility(status, img) {
      this.toggleProductDetailImgVisibility({status, img});
    },
    clickShowMoreRecommended() {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.showMoreRecommend();
      }, 600);
    },
    onClickBrand(brand) {
      if (brand) {
        if (this.$router.currentRoute.path !== '/collections') {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewSearch(brand, 'Brand');
          }, 600);
        } else {
          this.$root.selectNewSearch(brand, 'Brand');
        }
      }
    },
    clickPrev(id) {
      this.getPrev(id).then(res => {
        if (res && res.data && res.data[0]) {
          this.$router.push(`/productDetails?productNum=` + res.data[0].ProductNum);
        }
        })
          .catch(err => {
            console.log('error previous', err)
          });
    },
    clickNext(id) {
      this.getNext(id).then(res => {
        if (res && res.data && res.data[0]) {
          this.$router.push(`/productDetails?productNum=` + res.data[0].ProductNum);
        }
        })
          .catch(err => {
            console.log('error next ', err)
          });
    },
    findFavorites(product) {
      this.getFavorites()
      .then((res) => {
        let favorite = res.data.find(({ProductNum}) => {
          let num = product.productNum ? product.productNum : product.ProductNum
          return num === ProductNum;
        });
        this.favorited = (typeof favorite !== 'undefined');
      })
    },
    favoriteProduct(product) {
      if (this.favorited) {
        this.removeProductFromFavorites(product.Product_id)
      } else if (!this.favorited) {
        this.addProductToFavorites(product.Product_id)
      }
    },
    goToGroup(group) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewGroup(group);
      }, 600);
    },
    goToCategory(category) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewCategory(category);
      }, 600);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    setSeoFun({})
    next();
  },
  computed: mapState({
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cart: state => state.cart.cart,
    cartProductsList: state => state.cart.cartProductsList,
    productDetails: state => state.products.productDetails,
    itemCount: state => state.cart.itemCount,
    itemDeleted: state => state.cart.itemDeleted,
    activeQuantity: state => state.products.activeQuantity,
    groups: state => state.navbar.allGroups,
    favoriteSuccess: state => state.products.favoriteSuccess,
    favoriteLoading: state => state.products.favoriteLoading,
    loggedIn: state => state.auth.loggedIn,
    windowWidth: state => state.navbar.windowWidth,
    showPrice: state => state.auth.showLevel5Price,
    lowerLimitGlobal: state => state.products.lowerLimitGlobal,
    upperLimitGlobal: state => state.products.upperLimitGlobal,
    showInstock: state => state.auth.showInstock,
    showLimit1: state => state.auth.showLimit1,
    showLimit2: state => state.auth.showLimit2,
    isMobile() {
      return this.windowWidth < 800;
    },
  }),
  watch: {
    favoriteSuccess: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.findFavorites(this.product);
      }
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        this.fetchProductDetails(newVal.productNum);
        this.updateActiveProduct(newVal.productNum);
        this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
        this.initializeTabImg();
        if (isUserAuthenticated()) {
          this.findFavorites(newVal)
        }

      },
      // $route(to, from) {
      //   this.bigImg = "";
      //   this.zoomImg = "";
      // },
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        let quantFound = false;
        //Unfortunately, because `item.quantity` is used in other places, we can't combine the authenticated and unauthenticated mapping into one function and use || to delineate between the local storage cart and api cart. --Anthony
          if (isUserAuthenticated()) {
            this.cartProductsList.Sales_Order_Lines.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.Quantity)
              }
            })
          } else {
              this.cartProductsList.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.quantity)
              }
            })
          }
        if (!quantFound) {
          this.updateActiveQuantity(0);
        }
      }
    },
     product(newVal, oldVal) {
       if(!newVal) {
         return
       }
       setSeoFun(newVal)
       this.starIndex = [];
       if (newVal.Rating || newVal.Rating === 0) {
        for (let i=1; i<6; i++) {
          if (newVal.Rating >= i) {
          this.starIndex.push(star2);
          } else if (newVal.Rating > (i-1) && newVal.Rating < i) {
          this.starIndex.push(star1);
          } else if (newVal.Rating <= (i-1)) {
          this.starIndex.push(star0);
          }
        }
        this.starRating = newVal.Rating;
       } else {
         this.starIndex = [star0, star0, star0, star0, star0];
         this.starRating = 0;
       }
    },
    $route(to, from) {
      this.bigImg = "";
      this.zoomImg = "";
      // this.sharing.url = 'https://afmstage-web.truckxi.com' + this.$router.currentRoute.fullPath;
      this.sharing.url = 'https://shopafm.com' + this.$router.currentRoute.fullPath;
    },
  }
}
$(function () {
  $('.sp-wrap').smoothproducts();
})
</script>

<style lang="less">
// @import "../assets/css/public.less";
@import "../assets/css/details.less";
@import "../assets/css/jqzoom.css";
@import "../assets/css/navbar.less";
@import "../assets/css/smoothproducts.css";
@import "../assets/css/modalNew.less";
</style>



// WEBPACK FOOTER //
// src/view/productDetails.vue